module.exports = __webpack_public_path__ + "853ca97d3aa993fba2a5fdf646274741.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/eye.png
// module id = 278
// module chunks = 0